import {
	AfterViewInit,
	ChangeDetectionStrategy,
	Component,
	ElementRef,
	HostBinding,
	OnInit,
	ViewChild,
	ChangeDetectorRef 
} from "@angular/core";
import { LayoutConfigService } from "./core/services/layout-config.service";
import { ClassInitService } from "./core/services/class-init.service";
import * as objectPath from "object-path";
import { DomSanitizer } from "@angular/platform-browser";
import { NavigationEnd, Router } from "@angular/router";
import { PageConfigService } from "./core/services/page-config.service";
import { filter } from "rxjs/operators";
import { SplashScreenService } from "./core/services/splash-screen.service";
import { environment } from "@environments/environment";
import { LoginTipleri } from "@core/genel/AppEnums";
import { CustomFavicon } from "@core/utils/favicon.config";
import { CustomerService } from "@core/services/customer.service";
import { IconsService } from "@core/services/layout/icons.service";
import { SignalRService } from "@core/services/signalr.service";
import { AktifKullaniciBilgisiService } from "@core/auth/aktif-kullanici-bilgisi.service";

@Component({
	selector: "body[m-root]",
	templateUrl: "./app.component.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements AfterViewInit, OnInit {
	@HostBinding("style") style: any;
	@HostBinding("class") classes: any = "";

	@ViewChild("splashScreen", { static: true }) splashScreen: ElementRef;
	splashScreenImage: string;
	loginTipi: number = environment.LOGIN_TIPI;
	config: any;
	public CustomFavicon: typeof CustomFavicon = CustomFavicon;

	public message: string;

	constructor(
		private layoutConfigService: LayoutConfigService,
		private classInitService: ClassInitService,
		private sanitizer: DomSanitizer,
		private router: Router,
		private pageConfigService: PageConfigService,
		private splashScreenService: SplashScreenService,
		public customerService: CustomerService,
		iconService: IconsService,
		private signalRService: SignalRService,
		private cdr: ChangeDetectorRef,
		public aktifKullaniciBilgisiService: AktifKullaniciBilgisiService
	) {

		iconService.setIcon();

		this.setFaviconAndTitle();

		// subscribe to class update event
		this.classInitService.onClassesUpdated$.subscribe((classes) => {
			// get body class array, join as string classes and pass to host binding class
			setTimeout(() => (this.classes = classes.body.join(" ")));
		});

		this.layoutConfigService.onLayoutConfigUpdated$.subscribe((model) => {
			this.classInitService.setConfig(model);

			this.style = "";
			if (objectPath.get(model.config, "self.layout") === "boxed") {
				const backgroundImage = objectPath.get(
					model.config,
					"self.background"
				);
				if (backgroundImage) {
					this.style = this.sanitizer.bypassSecurityTrustStyle(
						"background-image: url(" +
							objectPath.get(model.config, "self.background") +
							")"
					);
				}
			}

			//	splash screen image
			if(customerService.settings.name == "sef"){
				this.splashScreenImage =
				"./assets/app/media/img/logos/sef.png";
			}
			else if(customerService.settings.name == "unidoxstyle"){
				this.splashScreenImage =
				"./assets/app/media/img/logos/unidoxlogin.png";
			}
			else if (customerService.settings.name == "esnaf"){
				this.splashScreenImage =
				"./assets/app/media/img/logos/esnaf-logo-dark.png";
			}
			else{
				if (this.loginTipi == LoginTipleri.turkFatura)
				this.splashScreenImage =
					"./assets/app/media/img/logos/amblem.png";
				else if (this.loginTipi == LoginTipleri.makbuzTek)
				this.splashScreenImage =
					"./assets/app/media/img/logos/makbuztek-logo.png";
				else if (this.loginTipi == LoginTipleri.turkMakbuz)
				this.splashScreenImage =
					"./assets/app/media/img/logos/amblem.png";

			}});

		// override config by router change from pages config
		this.router.events
			.pipe(filter((event) => event instanceof NavigationEnd))
			.subscribe(() => {
				this.layoutConfigService.setModel(
					{
						page: objectPath.get(
							this.pageConfigService.getCurrentPageConfig(),
							"config"
						),
					},
					true
				);
			});

	}

	alertMessage: string = '';
	showAlert: boolean = false;



	ngOnInit(): void {
		const kullaniciBuroId = this.aktifKullaniciBilgisiService.aktifKullaniciBilgisi.KLNC_BR_ID;
		this.signalRService.startConnection(kullaniciBuroId);
		this.signalRService.sendEveryoneNotificationListener();
		this.signalRService.onEveryoneNotificationReceiver.subscribe(notification => {
			this.showAlertMessage(notification.message)
		})

		// producion ortamında google analytics script ekleniyor
		if (environment.production) {
			this.loadGoogleAnalyticsScript();

			// her sayfa geçişinde, güncel url bilgisi iletiliyor.
			this.router.events.subscribe((event) => {
				if (event instanceof NavigationEnd) {
					if (this.loginTipi == LoginTipleri.turkFatura) {
						(<any>window).gtag("config", "UA-39161327-18", {
							page_path: event.urlAfterRedirects,
						});
					} else if (this.loginTipi == LoginTipleri.makbuzTek) {
						(<any>window).gtag("config", "UA-39161327-19", {
							page_path: event.urlAfterRedirects,
						});
					} else if (this.loginTipi == LoginTipleri.turkMakbuz) {
						(<any>window).gtag("config", "UA-39161327-20", {
							page_path: event.urlAfterRedirects,
						});
					}
				}
			});
		}
	}

	public showAlertMessage(message: string) {
		this.alertMessage = message;
		this.showAlert = true;
		this.cdr.detectChanges();
		setTimeout(() => {
		  this.showAlert = false;
		  this.cdr.detectChanges();
		}, 10000);
	}

	ngAfterViewInit(): void {
		if (this.splashScreen) {
			this.splashScreenService.init(this.splashScreen.nativeElement);
		}
	}

	loadGoogleAnalyticsScript() {
		let code: string = "";

		if (this.loginTipi == LoginTipleri.turkFatura) {
			code = "UA-39161327-18";
		} else if (this.loginTipi == LoginTipleri.makbuzTek) {
			code = "UA-39161327-19";
		} else if (this.loginTipi == LoginTipleri.turkMakbuz) {
			code = "UA-39161327-20";
		}

		// uygulama login tipine göre google analytics script ekleniyor.
		let node = document.createElement("script");
		node.type = "text/javascript";
		node.async = true;
		node.charset = "utf-8";
		node.src = "https://www.googletagmanager.com/gtag/js?id=" + code;
		document.getElementsByTagName("head")[0].appendChild(node);

		// uygulama login tipine göre google analytics'i çağıran script ekleniyor.
		let node2 = document.createElement("script");
		node2.type = "text/javascript";
		node2.charset = "utf-8";
		let content =
			"window.dataLayer = window.dataLayer || []; " +
			" function gtag() { dataLayer.push(arguments); }" +
			" gtag('js', new Date());";
		// + " gtag('config', '" + code + "')";
		node2.appendChild(document.createTextNode(content));
		document.getElementsByTagName("head")[0].appendChild(node2);
	}

	changeSplash():string{

		var logoName = 'assets/app/media/img/logos/'+ this.customerService.settings.name +'.png'

		return logoName;
	}

	private setFaviconAndTitle(): void {
		const faviconUrl = this.getFaviconUrl();
		const title = this.getPageTitle();
	
		// Set title directly
		document.title = title;
	
		// Set or create the favicon link
		let link: HTMLLinkElement | null = document.querySelector("link[rel*='icon']");
		if (!link) {
			link = document.createElement('link');
			link.rel = 'icon';
			document.head.appendChild(link);
		}
		link.type = 'image/x-icon';
		link.href = faviconUrl;
	}
	
	private getFaviconUrl(): string {
		if (this.customerService.settings.name === 'sef') {
			return ''; // "/assets/demo/default/media/img/logo/sef.png"
		}
		else if (this.customerService.settings.name === 'unidoxstyle') {
			return './assets/app/media/img/logos/unidoxlogin.png';
		}
		else if (this.customerService.settings.name === 'esnaf') {
			return '/assets/demo/default/media/img/logo/favicon-v2.ico';
		}
		else {
			switch (this.loginTipi) {
				case LoginTipleri.makbuzTek:
					return '/assets/demo/default/media/img/logo/favicon-makbuztek.ico';
				case LoginTipleri.turkMakbuz:
				case LoginTipleri.turkFatura:
					return '/assets/demo/default/media/img/logo/favicon-v2.ico';
				default:
					return '/favicon.ico';
			}
		}
	}
	
	private getPageTitle(): string {
		if (this.customerService.settings.name === 'sef') {
			return 'Şef';
		}
		else if (this.customerService.settings.name === 'unidoxstyle') {
			return 'Unidox';
		}
		else if (this.customerService.settings.name === 'esnaf') {
			return 'Esnaf Turk Fatura';
		}
		else {
			switch (this.loginTipi) {
				case LoginTipleri.makbuzTek:
					return 'MakbuzTek - TBB Avukatların Elektronik Serbest Meslek Makbuzu Portalı';
				case LoginTipleri.turkMakbuz:
					return 'TurkMakbuz';
				case LoginTipleri.turkFatura:
					return 'TurkFatura';
				default:
					return 'Uygulama';
			}
		}
	}
}
